import { render, staticRenderFns } from "./ScenePages.vue?vue&type=template&id=4b789057&scoped=true&"
import script from "./ScenePages.vue?vue&type=script&lang=js&"
export * from "./ScenePages.vue?vue&type=script&lang=js&"
import style0 from "./ScenePages.vue?vue&type=style&index=0&id=4b789057&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b789057",
  null
  
)

export default component.exports